import * as React from "react";
import { Container, Form, FormButton, FormDropdown, FormField, FormInput, Message } from "@/components/bp/bp-ui";
import { FormikProps, Formik, FieldArray, Field } from "formik";
import { FormErrorList } from "../FormErrorList";
import { CaseClient, ClientResources, EvidenceClient, KitSystemModel, LabKitClient, SampleClient } from "@app/api2/api";
import * as yup from "yup";
import SemanticField from "../../SemanticField";
import { IUploadedFile } from "../FileUpload";
import { IDropdownItem } from "../IDropdownItem";
import { PageHeader } from "@common/PageHeader";
import { insertComponentsIntoText } from "@common/Utils";
import { Link } from "react-router-dom";
import { buildUrl, AppRoutes } from "../AppRoutes";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import { TranslationContext } from "../Contexts/TranslationContext";
import { BPContainer } from "@/components/bp/bpcontainer";

export class KeyboardUploadFormValues {
    public kitId: number;
    public name: string;

    public systems: Array<Locus>;
    public dateOfBirth?: Date;

}

export class Locus {
    constructor(m: KitSystemModel) {
        this.name = m.name;
        //this.alleles = m..alleles.map(x => new Allele(x));
    }
    public name: string;
    public allele1: string;
    public allele2: string;
    //public alleles: Array<Allele>;
}


export class KeyboardUploadProps {
    // public sampleId: number;
    public labId: number;
    public caseId: number;
}

export class KeyboardUploadState {
    public formData: KeyboardUploadFormValues = new KeyboardUploadFormValues();
    public loading: boolean = true;
    public kitList: Array<IDropdownItem<number>> = [];
    serverErrors: string[];
    showServerErrors: boolean = false;

    previewErrors: string[];
    showPreviewErrors: boolean = false;

    showSampleNames: boolean = false;
    sampleNames: Array<{ name: string, message: string }> = [];

    caseName: string;
}


export class KeyboardUpload extends React.Component<KeyboardUploadProps, KeyboardUploadState> {

    private createSchema = yup.object().shape({
        name: yup.string().required().label(window.translation.sample.name),

        kitId: yup.number().required().label(window.translation.common.kit),
        //    file: yup.object().shape({
        //        fileName: yup.string().required(window.translation.sample.sampleFile),
        //    }),
    });
    //private editSchema = yup.object().shape({
    //    kitId: yup.number().required().label(window.translation.common.kit),
    //    name: yup.string().required().label(window.translation.sample.name),
    //});
    private kitClient = new LabKitClient();
    private sampleClient = new SampleClient();
    private evidenceClient = new EvidenceClient();
    private caseClient = new CaseClient();

    constructor(props, context) {
        super(props, context);

        this.state = new KeyboardUploadState();
    }

    public render() {
        //if (this.props.sampleId) {
        //    return (
        //        <Formik isInitialValid={true} enableReinitialize={true} initialValues={this.state.formData} render={this.renderEditForm} onSubmit={this.submitEdit} validationSchema={this.editSchema} />
        //    );

        //} else {
        return (
            <BPContainer>
                <PageHeader header={insertComponentsIntoText(window.translation.sampleView.uploadTitle, {
                    '{sampleName}': this.state.formData.name,
                    '{caseName}': <Link key={'caseLink'} to={buildUrl(AppRoutes.CaseDetails, {
                        caseId: this.props.caseId,
                        labId: this.props.labId
                    })}>{this.state.caseName || '-'}</Link>
                })} />

                <Formik initialValues={this.state.formData} onSubmit={this.submitCreate} validationSchema={this.createSchema}>
                    {(props) => {
                        return this.renderCreateForm(props);
                    }}
                </Formik>
            </BPContainer>
        );
        //}
    }

    public async componentDidMount(): Promise<any> {
        const kits = await this.caseClient.getCaseKits(this.props.labId, this.props.caseId);

        const evidence = await this.evidenceClient.getForUpload(this.props.labId, this.props.caseId);

        this.setState({
            caseName: evidence.caseName,
        });

        this.setState({
            loading: false,
            kitList: kits.map((k) => ({ key: k.id, value: k.id, text: k.fullName })),
        });
    }

    async loadKitSystems(kitId: number, props: FormikProps<KeyboardUploadFormValues>) {
        // console.log(kitId);
        const systems = await this.kitClient.getSystems(kitId, this.props.labId);
        // console.log(systems);
        await props.setFieldValue("systems", systems.systems.map(x => new Locus(x)));
    }

    private getFilePreview = async (file: IUploadedFile) => {
        const result = await this.sampleClient.preview(this.props.labId, this.props.caseId,
            {
                kitId: 0,
                sampleFile: file.contents
            });

        if (!result.successful) {
            this.setState({
                showPreviewErrors: true,
                showSampleNames: false,
                sampleNames: [],
                previewErrors: result.errors.map((e) => (e.value))
            });
        } else {
            this.setState({
                showPreviewErrors: false,
                showSampleNames: true,
                previewErrors: [],
                sampleNames: result.newSample.map((e) => {
                    return { name: e.name, message: e.warning };
                })
            });
        }
    };

    private renderCreateForm = (props: FormikProps<KeyboardUploadFormValues>) => {
        const handleChange = async (e, data) => {
            if (data && data.name) {
                await props.setFieldTouched(data.name);
                await props.setFieldValue(data.name, data.value);
                this.setState({ formData: { ...this.state.formData, [data.name]: data.value } });

                if (data.name === "file") {
                    this.getFilePreview(data.value);
                }
            }
        };

        const canSubmit = () => {
            return props.isValid && (!this.state.showPreviewErrors);
        };

        const errorList = Object.getOwnPropertyNames(props.errors)
            .filter((k) => props.touched[k])
            .map((k) => props.errors[k]);

        return (<TranslationContext.Consumer>{(t) => <Form loading={this.state.loading} onSubmit={props.handleSubmit}>
            <div className="ui segment">
                <SemanticField component={FormDropdown} onChange={(e, newValue) => this.loadKitSystems(newValue, props)} name="kitId" selection options={this.state.kitList} label={t.common.kit} value={props.values.kitId} error={props.errors.kitId && props.touched.kitId} />
                <SemanticField component={FormInput} name="name" label={t.sample.name} value={props.values.name} error={props.errors.name && props.touched.name} />
                <FormField>
                    <label>{t.sample.dateOfBirth}</label>
                    <Field as={ReactDatePicker} isClearable={true} showYearDropdown selected={props.values.dateOfBirth ? moment(props.values.dateOfBirth).toDate() : null} onChange={async(ev)=>{
                        await props.setFieldValue('dateOfBirth', ev as Date != null ? moment(ev as Date).format("MM/DD/YYYY") : null)
                    }}>
                    </Field>
                </FormField>
                <FieldArray
                    name="systems"
                    render={arrayHelpers => (
                        <table className="ui compact definition table striped">
                            <thead>
                                <tr>
                                    <th>{t.common.system}</th>
                                    <th>{t.common.allele}</th>
                                    <th>{t.common.allele}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(props.values.systems || []).map((system, index) => (
                                    <tr key={index}>
                                        <td>{system.name}</td>
                                        <td>
                                            <SemanticField name={`systems[${index}].allele1`} component={FormInput} />
                                        </td>
                                        <td>
                                            <SemanticField name={`systems[${index}].allele2`} component={FormInput} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )} />
                {/*<Form.Field>*/}
                {/*    <label>{t.sample.sampleFile}</label>*/}
                {/*    <FileUpload placeholderText={t.sample.sampleFile} name="file" fileUploaded={handleChange} value={props.values.file} />*/}
                {/*</Form.Field>*/}
                <FormButton disabled={!canSubmit()}>{t.common.save}</FormButton>
                <Message error header={t.common.errorsOnForm} list={errorList} visible={errorList.length > 0} />
                <FormErrorList message={t.sample.fileErrors} show={this.state.showServerErrors} errors={this.state.serverErrors} />
                <FormErrorList message={t.sample.fileCannotBeProcessed} show={this.state.showPreviewErrors} errors={this.state.previewErrors} />
                {this.state.showSampleNames && <Message info header={t.sample.sampleNames} list={this.state.sampleNames.map(m => `${m.name} ${m.message ? `(${m.message})` : ""}`)} />}
            </div>

        </Form>}</TranslationContext.Consumer>);
    };

    private submitCreate = async (values: KeyboardUploadFormValues): Promise<any> => {
        // console.log(values)
        this.setState({ loading: true });
        const result = await this.sampleClient.createKeyboard(this.props.labId, this.props.caseId,
            {
                kitId: values.kitId,
                name: values.name,
                systems: values.systems,
                dateOfBirth: values.dateOfBirth
            });

        if (result.successful) {
            window.location.assign(result.url);
        } else {
            this.setState({
                loading: false,
                serverErrors: result.errors.map((e) => e.value),
                showServerErrors: true,
            });
        }
    };
}
